export const categories = [
  {
    slug: 'wanghong-fanche',
    name: '网红翻车',
    description: '追踪网红圈最新翻车事件，揭秘百万博主背后的真实面目，吃瓜第一线实时更新',
    icon: 'ri-alert-line',
  },
  {
    slug: 'yulequan',
    name: '娱乐圈',
    description: '娱乐圈最新动态、明星八卦、综艺内幕，为你呈现最真实的娱乐世界',
    icon: 'ri-star-line',
  },
  {
    slug: 'zuixin-dagua',
    name: '最新大瓜',
    description: '全网最新最热的爆料大瓜汇总，第一时间掌握吃瓜资讯，不错过任何精彩',
    icon: 'ri-fire-line',
  },
  {
    slug: 'dujia-baoliao',
    name: '独家爆料',
    description: '91爆料网独家深度调查内容，为你揭露不为人知的幕后真相',
    icon: 'ri-spy-line',
  },
  {
    slug: 'remen-shipin',
    name: '热门视频',
    description: '精选最火爆的爆料视频，实拍画面+深度解析，让你看得过瘾',
    icon: 'ri-video-line',
  },
];